class ColorSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', (event) => {
      const input = event.target.closest('.card__swatch-input');
      if (!input) return;

      const data = JSON.parse(input.closest('.card__swatch').querySelector('script').textContent);
      const productCard = this.closest('.card-wrapper');
      const image = data?.featured_image;
      const href = input.dataset.href;

      // Change the link
      if (href) {
        productCard.querySelectorAll('h3 a').forEach((productLink) => {
          productLink.href = href;
        });

        productCard.querySelectorAll('.card__media > a').forEach((productLink) => {
          productLink.href = href;
        });
      }

      // Change the media
      const currentMedia = productCard.querySelectorAll('.card__media .media > img');

      if (image) {
        // Always replace the main image
        var imgIndex = 0;
        if (currentMedia[1]) {
          imgIndex = 1;
        }
        currentMedia[imgIndex].src = image.src + '&width=600';
        currentMedia[imgIndex].setAttribute('srcset', image.src + '&width=600');
        currentMedia[imgIndex].alt = image.alt;
        currentMedia[imgIndex].style.opacity = 1;
      }
    });
  }
}

customElements.define('color-swatches', ColorSwatches);
